import { type SalesPageMetric } from "@north-beam/nb-client-side";
import { type MetricPrecision } from "@north-beam/nb-common/formatting";
import { MetricValue } from "@shared/metric-value";
import Spinner from "@shared/spinner";

export const MetricCard = ({
  title,
  value,
  metric,
  loading,
  precision = "exact",
}: {
  title: string;
  value: number | null;
  metric: SalesPageMetric | undefined;
  loading: boolean;
  precision?: MetricPrecision;
}) => {
  return (
    <div className="flex-1 border rounded-lg min-h-[80px] flex flex-col px-4 pt-4 pb-1">
      <div className="font-bold text-base leading-3">{title}</div>
      <div className="flex-1 flex items-center">
        {loading && <Spinner style={{ fontSize: "14px" }} />}
        {!loading && value && metric && (
          <div className="text-cosmic tracking-wide text-xl leading-6">
            <MetricValue
              as="span"
              format={metric.format}
              value={value}
              precision={precision}
            />
          </div>
        )}
      </div>
    </div>
  );
};
